import { inject } from "@angular/core";
import { ResolveFn, Router } from "@angular/router";
import { catchError } from "rxjs/operators";
import { EMPTY } from "rxjs";
import { EnrollmentCodeService } from "../services/enrollment-code.service";

export const validEnrollmentCodeResolver: ResolveFn<object> = (
  route,
  state,
) => {
  const enrollmentCodeService = inject(EnrollmentCodeService);
  const router = inject(Router);
  const id = route.queryParamMap.get("enrollmentCode");
  if (id) {
    return enrollmentCodeService.validateCode(id).pipe(
      catchError((err) => {
        router.navigate(["/login"]);
        return EMPTY;
      }),
    );
  } else {
    return;
  }
};
